import React, { Component } from 'react';
import userRoles from 'utils/enums/user-roles.enum';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomTextField from 'components/CustomTextField/CustomTextField';
import { verifyEmail } from 'plugins/validation/validation-rules';

import styles from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';
const newStyles = {
	...styles,
	inviteContainer: {
		padding: '0px 5px !important',
		width: '100%',
		margin: '0',
		textAlign: 'left',
	}
};

class InviteUserForm extends Component {

	state = {
		role: userRoles.Admin,
		email: '',
		isEmailError: false,
	};

	componentDidMount() {
		const { role, email } = this.state;
		const { innerFormState, setStateFromChild, } = this.props;
		innerFormState
			? this.setState({
				...innerFormState,
			}, this.validateEmailInput)
			: setStateFromChild({
				innerFormState: {
					role,
					email,
				},
			});
	}

	onChangeRole = (e) => {
		const { setStateFromChild, innerFormState } = this.props;
		const value = e.target.value;
		this.setState({
			role: value,
		});
		setStateFromChild({
			innerFormState: {
				...innerFormState,
				role: value,
			},
		});
	};

	validateEmailInput = () => {
		const { email } = this.state;
		const { setStateFromChild } = this.props;
		const isValid = verifyEmail(email);
		this.setState({
			isEmailError: !isValid,
		});
		setStateFromChild({
			isSubmitDisabled: !isValid,
		});
	};

	onChangeEmail = (e) => {
		const { setStateFromChild, innerFormState } = this.props;
		const value = e.target.value;
		this.setState({
			email: value,
		}, this.validateEmailInput);
		setStateFromChild({
			innerFormState: {
				...innerFormState,
				email: value,
			},
		});
	};

	render() {
		const { role, email, isEmailError, } = this.state;
		const {
			classes,
			renderProps,
		} = this.props;

		return (
			<GridContainer className={classes.inviteContainer}>
				<GridItem xs={12} sm={12} md={12}>
					<CustomTextField
						classes={classes}
						label={'Email *'}
						inputRef={renderProps.setAutoFocusInputRef}
						error={isEmailError}
						helperText={isEmailError ? "Please enter valid email" : ""}
						formControlProps={{
							fullWidth: true,
						}}
						fullWidth={true}
						inputProps={{
							autoComplete: 'new-email',
							value: email,
						}}
						onChange={(event) => {
							this.onChangeEmail(event);
						}}
						onBlur={() => {
							this.validateEmailInput();
						}}
					/>
				</GridItem>
			</GridContainer>
		);
	}
}

export default withStyles(newStyles)(InviteUserForm);
